module.exports = __webpack_public_path__ + "assets/img/21_1496_big.bdc61886.jpg";